import { LogLevel } from '../app/core/models';

/**
 * Development server environment configuration
 */
export const environment = {
  production: false,

  // Log level: Show info and above on dev server
  logLevel: LogLevel.debug,

  urls: {
    // UPAPI Backend (Spring Boot)
    apiUrl: 'https://dev.upapi.co/api/v1/public',
    yearbookMasterUrl: 'https://dev.app.yearbook-master.com/',
    // Admin API (JWT-protected endpoints)
    adminApiUrl: 'https://dev.upapi.co/api/v1',
  },

  // Keycloak authentication (admin routes only)
  keycloak: {
    url: 'https://dev.auth.upapi.co',
    realm: 'yearbook-master',
    clientId: 'proof-preview',
    idpHint: 'yearbook-master',
  },
};
